import styled from "styled-components";

export const SearchIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
  margin-left: 15px;
`;
